import { Component, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ScaButtonComponent, ScaIconComponent } from '@argo-dev-components-sca-angular/dev-components-sca';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, ScaButtonComponent, ScaIconComponent],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  videoUrl = '/videos/argov8.mp4';
  isPlaying = false;
  isMuted = false;
  isPaused = false;
  volume = 100;

  constructor(private router: Router) {}

  onDiscoverTrailer() {
    console.log('🎬 Descubre el trailer');
    if (this.videoPlayer?.nativeElement) {
      this.videoPlayer.nativeElement.play();
      this.isPlaying = true;
    }
  }

  onDiscoverArgoV8() {
    console.log('🚀 Descubre Argo V8');
    this.router.navigate(['/test/auth']);
  }

  onVideoEnded() {
    console.log('🎬 Video terminado, volviendo al estado inicial');
    this.isPlaying = false;
    if (this.videoPlayer?.nativeElement) {
      this.videoPlayer.nativeElement.currentTime = 0;
    }
  }

  toggleMute() {
    if (this.videoPlayer?.nativeElement) {
      this.isMuted = !this.isMuted;
      this.videoPlayer.nativeElement.muted = this.isMuted;
    }
  }

  togglePlayPause() {
    if (this.videoPlayer?.nativeElement) {
      if (this.isPaused) {
        this.videoPlayer.nativeElement.play();
        this.isPaused = false;
      } else {
        this.videoPlayer.nativeElement.pause();
        this.isPaused = true;
      }
    }
  }

  onVolumeChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.volume = parseInt(input.value);
    if (this.videoPlayer?.nativeElement) {
      this.videoPlayer.nativeElement.volume = this.volume / 100;
      if (this.volume === 0) {
        this.isMuted = true;
        this.videoPlayer.nativeElement.muted = true;
      } else if (this.isMuted) {
        this.isMuted = false;
        this.videoPlayer.nativeElement.muted = false;
      }
    }
  }
}
